/**
 * Return the current landing page URL composed of origin + pathname.
 * No URL params
 *
 * @returns {string | undefined} The landing page URL (e.g. "https://example.com/path")
 *                              or `undefined` when not running in a browser.
 *
 * @example
 * const url = getLandingPageUrl();
 * // => "https://www.example.com/pricing"
 */
const getLandingPageUrl = (): string | undefined => {
    // safe guard for SSR / test environments
    if (typeof window === 'undefined' || !window.location) return;

    const { origin = '', pathname = '' } = window.location;

    return `${origin}${pathname}`;
};

export default getLandingPageUrl;
